import '../css/app.css';

import { createInertiaApp } from '@inertiajs/react';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { createRoot } from 'react-dom/client';
import { Toaster } from './components/ui/sonner';
import { Ziggy } from './ziggy';
import { route } from 'ziggy-js';

import { AchievementProvider } from './contexts/AchievementContext';
import { ThemeProvider } from './components/theme-provider';
import { AuthTransitionOverlay } from './components/ui/auth-transition-overlay';

// Ziggy'yi global olarak kullanılabilir hale getir
if (typeof window !== 'undefined') {
    (window as any).Ziggy = Ziggy;
    (window as any).route = route;
    
    // CSRF token'ı global olarak tanımla
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
    if (csrfToken) {
        (window as any).csrfToken = csrfToken;
    }
}

const appName = import.meta.env.VITE_APP_NAME || 'Okur Atölyesi';

createInertiaApp({
    title: (title) => title || appName,
    // Lazy load pages on-demand (eager: false)
    resolve: (name) => resolvePageComponent(`./pages/${name}.tsx`, import.meta.glob('./pages/**/*.tsx', { eager: false })),
    setup({ el, App, props }) {
        const root = createRoot(el);

        root.render(
            <>
                <ThemeProvider>
                    <AuthTransitionOverlay />
                    <Toaster />
                    <AchievementProvider>
                        <App {...props} />
                    </AchievementProvider>
                </ThemeProvider>
            </>,
        );
    },
    progress: {
        color: 'var(--primary)',
        showSpinner: true,
    },
});

// This will set light / dark mode on load...

